<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height"
    viewBox="0 0 24 24"
  >
    <g id="icon_list_menu" transform="translate(1597 2999)">
      <rect
        id="사각형_5791"
        data-name="사각형 5791"
        fill-opacity="0"
        width="24"
        height="24"
        transform="translate(-1597 -2999)"
      />
      <g
        id="그룹_11663"
        data-name="그룹 11663"
        transform="translate(-2516.83 -4095.345)"
      >
        <path
          id="패스_7173"
          data-name="패스 7173"
          fill="#087ef7"
          d="M11,3H3v8h8Z"
          transform="translate(919 1097)"
        />
        <path
          id="패스_7176"
          data-name="패스 7176"
          fill="#d5d8dc"
          d="M11,13H3v8h8Z"
          transform="translate(919 1097)"
        />
        <path
          id="패스_7174"
          data-name="패스 7174"
          fill="#ffc304"
          d="M16.66,1.69,11,7.34,16.66,13l5.66-5.66L16.66,1.69Z"
          transform="translate(919.34 1097)"
        />
        <path
          id="패스_7177"
          data-name="패스 7177"
          fill="#21bf54"
          d="M21,13H13v8h8Z"
          transform="translate(919 1097)"
        />
      </g>
    </g>
  </svg>
</template>
<script>
export default {
  props: {
    width: {
      type: Number,
      default: 24,
    },
    height: {
      type: Number,
      default: 24,
    },
  },
};
</script>
